import * as React from 'react';
import * as style from './BuilderItem.css';
import { Stats } from '../Stats';
import { BuilderLogo } from '../BuilderLogo';
import { trackTransferToDeveloperCard } from '../../analytics/trackTransferToDeveloperCard';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { BuilderLink } from '../BuilderLink';
import { MultipleBuildersInfo } from '../MultipleBuildersInfo';

export interface IBuilderItemProps {
  builders: INewbuildingBuilder[];
}

export const BuilderItem: React.FunctionComponent<IBuilderItemProps> = props => {
  const { builders } = props;

  if (builders.length === 0) {
    return null;
  }

  const isOnlyOneBuilder = builders.length === 1;

  const builder = builders[0];
  const { name, logoUrl, stats, profileUrl } = builder;

  return (
    <div className={style['container']} data-mark="Builders" data-testid="BuilderItem">
      {isOnlyOneBuilder && (
        <>
          <div className={style['info']}>
            <BuilderLink
              text={name}
              linkUrl={profileUrl}
              withIcon
              fontSize="M"
              onClick={trackTransferToDeveloperCard}
            />
            <Stats stats={stats} />
          </div>

          <BuilderLogo src={logoUrl} type="builder" />
        </>
      )}

      {!isOnlyOneBuilder && (
        <div className={style['info']}>
          <MultipleBuildersInfo builders={builders} onBuilderClick={trackTransferToDeveloperCard} />
        </div>
      )}
    </div>
  );
};
